import {CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {inject} from "@angular/core";
import {map} from "rxjs";
import {AuthService} from "../services/auth.service";

export const loggedInGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const redirectUrl: string = state.url;

  return authService.isLoggedIn().pipe(
    map((value: boolean) => {
      if (!value) {
        router.navigate(['/login'],
          {
            queryParams: {'redirect-url': redirectUrl}
          });
        return false;
      }

      return true;
    }));
};
